import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import './index.scss';

document.addEventListener('DOMContentLoaded', () => {
  const sliders = drupalSettings?.accessibleCustomSlider
    ? [drupalSettings?.accessibleCustomSlider]
    : [];

  sliders.forEach(({ selector, i18n }) => {
    // Use slider_selector inside the selector object
    const sliderSelector = selector.slider_selector;

    document.querySelectorAll(sliderSelector).forEach((slider) => {
      new Splide(slider, {
        type: 'loop',
        perPage: 1,
        accessibility: true,
        keyboard: 'global',
        pagination: true,
        wheel: true,
        autoplay: true,
        arrows: false,
        interval: 15000,
        speed: 2500,
        pauseOnHover: true,
        pauseOnFocus: true,
        mediaQuery: 'min',
        breakpoints: {
          1200: { perPage: 6 },
          900: { perPage: 4 },
          768: { perPage: 3 },
          600: { perPage: 2 },
        },
        i18n,
      }).mount();
    });
  });
});
